export default __webpack_public_path__ + "static/media/330_dummy2016-physiotherapie01-mobile-de.fa5253d8.png";